import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';
import { TextContentDataSchema, TextStyleOverrideSchema } from '@/components/canvas/elements/text/schema';

export const TriangleElementSchema = BaseElementSchema.extend({
  type: z.literal('triangle'),
  data: z.object({
    direction: z.enum(['up', 'down', 'left', 'right']).optional().default('up'),
    text: TextContentDataSchema.optional(),
    textStyle: TextStyleOverrideSchema.partial().optional(),
  }),
});
